// @flow
import update from 'immutability-helper';

import type { VirtualItem } from '../../shopping-cart/api';

export const VIRTUAL_BAG_STORAGE_KEY = 'virtualBag';

const _save = (obj: any) => {
  const str = JSON.stringify(obj);
  localStorage.setItem(VIRTUAL_BAG_STORAGE_KEY, str);
};

export const getVirtualBag = (): VirtualItem[] => {
  let s;
  const raw = localStorage.getItem(VIRTUAL_BAG_STORAGE_KEY);
  if (!!raw) {
    try {
      s = JSON.parse(raw);
    } catch (e) {
      console.error('Error parsing virtual bag', e);
    }
  }
  return (s: any);
};

export const setVirtualBag  = (virtualItem: VirtualItem[]) => _save(virtualItem);

export const addVirtualProduct = (bag: VirtualItem[]) => _save(bag);

export const editVirtualProduct = (index: number, amount?: number, shipping?: string) => {
  const bag: VirtualItem[] = getVirtualBag();
  const newValues: { [key: string]: any } = {};
  if (typeof amount === 'number' && !!amount) {
    newValues.amount = { $set: amount };
  }
  if (typeof shipping === 'string' && !!shipping) {
    newValues.shipping = { $set: shipping };
  }
  const newBag = update(bag, {
    items: {
      [index]: { ...newValues },
    },
  });
  _save(newBag);
};

export const removeVirtualBag = () => localStorage.removeItem(VIRTUAL_BAG_STORAGE_KEY);



// WEBPACK FOOTER //
// ./src/modules/bag/utils/virtual-bag-storage.js